import React from 'react'

//Node Modules
import { useTranslation } from 'react-i18next'
import {Row, Col, Dropdown} from 'react-bootstrap'

//Styles 
import styles from './DownloadContainer.module.scss'

//Util
import {Language, getLocalizedLanguages} from 'util/languages'

interface DropdownOption {
  key: string,
  value: string
}

interface Props {
  selectedLang: Language,
  selectedCas: DropdownOption,
  selectedFormat: DropdownOption,
  setSelectedLang: (lang: Language) => void,
  setSelectedCas: (cas: DropdownOption) => void,
  setSelectedFormat: (format: DropdownOption) => void
}

const DownloadSettings = ({
  selectedLang,
  selectedCas,
  selectedFormat,
  setSelectedLang,
  setSelectedCas,
  setSelectedFormat
}: Props) => {
  const { t } = useTranslation()

  const casOptions = [{key:'SAS', value: 'SAS'}, {key:'LUA', value: 'LUA'}, {key:'PYTHON', value: 'PYTHON'}, {key:'R', value: 'R'}]
  const formatOptions = [{key:'ZIP', value:'.zip'}, {key:'GZIP', value: '.gz'}]

  return (
    <>
      <Row className={styles.selectorRow}>
        <Col xs={12} sm={4} md={3} lg={2}>
        <label>{t('helpcenter-gui-icu.downloadpage.setting.language.label')}</label>
        </Col>
        <Col xs={12} sm={8} md={9} lg={10}>
          <Dropdown className={styles.dropdown}>
            <Dropdown.Toggle id="LanguageDropdown" size="sm">
              {selectedLang.name} {selectedLang.code !== 'en' ? ' ('+selectedLang.english+')' : ''}
            </Dropdown.Toggle>
            <Dropdown.Menu>
              {
                getLocalizedLanguages().map( lang => {
                return <Dropdown.Item key={lang.code} className={styles.dropdownItem} onSelect={()=>{setSelectedLang(lang)}}>{lang.name} {lang.code !== 'en' ? ' ('+lang.english+')' : ''}</Dropdown.Item>
                })
              }
            </Dropdown.Menu>
          </Dropdown>
        </Col>
      </Row>
      <Row className={styles.selectorRow}>
        <Col xs={12} sm={4} md={3} lg={2}>
          <label>{t('helpcenter-gui-icu.downloadpage.setting.cas.label')}</label>
        </Col>
        <Col xs={12} sm={8} md={9} lg={10}>
          <Dropdown className={styles.dropdown}>
            <Dropdown.Toggle id="CasDropdown" size="sm">
              {selectedCas.value}
            </Dropdown.Toggle>
            <Dropdown.Menu>
              {
                casOptions.map( cas => {
                return <Dropdown.Item key={cas.key} className={styles.dropdownItem} onSelect={()=>{setSelectedCas(cas)}}>{cas.key}</Dropdown.Item>
                })
              }
            </Dropdown.Menu>
          </Dropdown>
        </Col>
      </Row>
      <Row className={styles.selectorRow}>
        <Col xs={12} sm={4} md={3} lg={2}>
          <label>{t('helpcenter-gui-icu.downloadpage.setting.format.label')}</label>
        </Col>
        <Col xs={12} sm={8} md={9} lg={10}>
          <Dropdown className={styles.dropdown}>
            <Dropdown.Toggle id="FormatDropdown" size="sm">
              {selectedFormat.value}
            </Dropdown.Toggle>
            <Dropdown.Menu>
              {
                formatOptions.map( format => {
                return <Dropdown.Item key={format.key} className={styles.dropdownItem} onSelect={()=>{setSelectedFormat(format)}}>{format.key}</Dropdown.Item>
                })
              }
            </Dropdown.Menu>
          </Dropdown>
        </Col>
      </Row>
    </>
  )
}
export default DownloadSettings